export const SCOPES = import.meta.env.VITE_SCOPE;
export const BACKEND_API = import.meta.env.VITE_API_URL
export const APP_VERSION = import.meta.env.VITE_IMAGE_TAG